import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import password from "../assets/images/password.png";
import { changePassword } from '../services/ProfileApi';
import { showToast } from '../config/Alert';
import LoadingSpinner from './LoadingSpinner';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { old_password, new_password, confirm_password } = formData;

    if (!old_password || !new_password || !confirm_password) {
      showToast("All fields are required", "error");
      return;
    }

    if (new_password !== confirm_password) {
      showToast("New passwords do not match", "error");
      return;
    }

    try {
      setLoading(true);
      await changePassword({
        current_password: old_password,
        new_password: new_password
      });
      showToast("Password changed successfully!", "success");
      setFormData({ old_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      showToast(error.message || "Failed to change password", "error");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>
        <Form className='fs-12' onSubmit={handleSubmit}>
          <div className='AccountInnerMain d-flex align-items-center justify-content-between'>
            <h6>
              <img src={password} width={20} alt="user" />
              <span className='ps-1'> Change Password</span>
            </h6>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Old Password</Form.Label>
            <Form.Control type="password" name="old_password" className='border-2 fs-14' value={formData.old_password}
              onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control type="password" name="new_password" className='border-2 fs-14' value={formData.new_password}
              onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control type="password" name="confirm_password" className='border-2 fs-14' value={formData.confirm_password}
              onChange={handleChange} />
          </Form.Group>

          <Form.Group className='d-flex justify-content-between'>
            <Button variant="danger" size='sm' type="submit" className='px-3 rounded-5 text-white'>
              Change Password
            </Button>
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
};

export default ChangePassword;
